var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-0",attrs:{"small":"","label":"","color":_vm.chipColor,"text-color":_vm.textColor}},[_vm._v("\n  "+_vm._s(_vm.label || _vm.fallbackLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }